module.exports = __webpack_public_path__ + "static/img/female-bg-tr.51340673.png";